import React, { useEffect, useState } from "react";

import { useCommonService } from "pages/service";
import type { SnapshotDataTypes } from "pages/service";
import { CameraInfo } from "lib/types";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Button, Popover } from "antd";

export default function CameraNameWithSnapshotPop({
  camera,
}: {
  camera: CameraInfo;
}) {
  const { takeSnapshot } = useCommonService();
  const [mouseEntered, setMouseEntered] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [imageSrc, setImageSrc] = useState("");

  // const [imageLoading, setImageLoading] = useState(false);

  useEffect(() => {
    if (!mouseEntered || imageLoading || imageSrc) {
      return;
    }
    setHasError(false);
    let streamId;
    if (camera?.capabilities?.streamNum > 1) streamId = 1;
    const _camera = {
      id: +camera.id,
      macAddress: camera.macAddress,
      remoteIndex: camera.remoteIndex,
      streamId: streamId,
    };

    setImageLoading(true);
    takeSnapshot(
      +camera?.nvrId,
      [_camera],
      camera?.orgId.toString(),
      (snapshots: SnapshotDataTypes[]) => {
        const curSnapshot = snapshots.filter((e) => e.id === camera.id);
        if (curSnapshot?.length > 0) {
          setImageLoading(false);
          setImageSrc(URL.createObjectURL(curSnapshot?.at(0)?.blob));
        }
      },
    ).then((errorCameras) => {
      if (errorCameras?.length > 0) {
        setImageLoading(false);
        setHasError(true);
      }
    });
  }, [mouseEntered]);

  const content = (
    <div className=" flex justify-center items-center bg-zinc-100 rounded-2xl w-[350px] aspect-video overflow-hidden">
      {imageSrc && (
        <TransformWrapper
          initialScale={1}
          initialPositionX={0}
          initialPositionY={0}
          centerOnInit={true}
          disablePadding={true}
          doubleClick={{ disabled: true }}
        >
          {() => (
            <React.Fragment>
              <TransformComponent
                wrapperClass="!w-full !h-full"
                contentClass="!w-full !h-full flex justify-center items-center"
              >
                <img
                  src={imageSrc}
                  className="max-w-full max-h-full object-contain"
                />
              </TransformComponent>
            </React.Fragment>
          )}
        </TransformWrapper>
      )}

      {imageLoading && (
        <div
          className="ml-1 text-blue-500  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status"
        ></div>
      )}
      {hasError && <p className="text-sm  text-black">Snapshot error</p>}
    </div>
  );

  return (
    <Popover
      content={content}
      title=""
      onOpenChange={setMouseEntered}
      placement="right"
      arrow={false}
      overlayInnerStyle={{
        padding: 0,
        borderRadius: "16px",
      }}
    >
      <div
        className="relative"
        // onMouseEnter={() => setMouseEntered(true)}
        // onMouseLeave={() => setMouseEntered(false)}
      >
        <span className="font-semibold cursor-pointer">{camera.name}</span>
        {/* {mouseEntered && imageSrc && (
          <div className="absolute z-[10] -right-0  top-1/2 translate-x-full -translate-y-1/2 flex justify-center items-center bg-zinc-100 aspect-video rounded-2xl w-[220px] h-[124px] overflow-hidden">
            <TransformWrapper
              initialScale={1}
              initialPositionX={0}
              initialPositionY={0}
              centerOnInit={true}
              disablePadding={true}
              doubleClick={{ disabled: true }}
            >
              {() => (
                <React.Fragment>
                  <TransformComponent
                    wrapperClass="!w-full !h-full"
                    contentClass="!w-full !h-full flex justify-center items-center"
                  >
                    <img
                      src={imageSrc}
                      className="max-w-full max-h-full object-contain"
                    />
                  </TransformComponent>
                </React.Fragment>
              )}
            </TransformWrapper>
          </div>
        )}

        {mouseEntered && imageLoading && (
          <div className="absolute z-[10] -right-0  top-1/2 translate-x-full -translate-y-1/2 flex justify-center items-center bg-zinc-100 aspect-video rounded-2xl w-[220px] h-[124px] overflow-hidden">
            <div
              className="ml-1 text-blue-500  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
              role="status"
            ></div>
          </div>
        )}
        {mouseEntered && hasError && (
          <div className="absolute z-[10] -right-0  top-1/2 translate-x-full -translate-y-1/2 flex justify-center items-center bg-zinc-100 rounded-2xl w-[200px] h-[124px] overflow-hidden">
            <p className="text-sm font-semibold">Snapshot error</p>
          </div>
        )} */}
      </div>
    </Popover>
  );
}
